import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../store/authSlice';
import './LoginRegisterModal.css';

const LoginRegisterModal = () => {
    const dispatch = useDispatch();
    const { token } = useSelector(state => state.auth);

    // Dynamic UI State Mapping Switches
    const [isOpen, setIsOpen] = useState(false);
    const [authMode, setAuthMode] = useState('login'); // Options: 'login' | 'register' | 'forgot'
    
    // Form Inputs Management Elements
    const [formData, setFormData] = useState({ name: '', email: '', password: '', phone: '' });
    const [localError, setLocalError] = useState(null);
    const [actionLoading, setActionLoading] = useState(false);

    // Expose dynamic toggle hooks globally via window listener handles for legacy CRA bindings
    React.useEffect(() => {
        const handleToggle = (e) => {
            setIsOpen(true);
            if (e.detail?.mode) setAuthMode(e.detail.mode);
        };
        window.addEventListener('TRIGGER_AUTH_MODAL', handleToggle);
        return () => window.removeEventListener('TRIGGER_AUTH_MODAL', handleToggle);
    }, []);

    if (!isOpen || token) return null; // Terminate rendering instantly if user authenticates or modal closes

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setLocalError(null);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setActionLoading(true);
        setLocalError(null);

        // 🎯 FIX 1: Determine correct endpoint based on mode
        let targetEndpoint = 'login.php';
        if (authMode === 'register') {
            targetEndpoint = 'register.php';
        } else if (authMode === 'forgot') {
            targetEndpoint = 'forgot-password.php';
        }
        
        try {
            const response = await fetch(`https://rbuymart.rbhardwaj.com/server/api/auth/${targetEndpoint}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            const data = await response.json();

            if (!response.ok) throw new Error(data.message || 'API verification processing failure.');

            if (authMode === 'login') {
              // 1. हमेशा सामान्य यूज़र टोकन सेट करें
    localStorage.setItem('token', data.token);

    // 2. केवल तभी admin_token सेट करें जब यूज़र सच में Admin हो
    if (data.user && data.user.role === 'admin') {
        localStorage.setItem('admin_token', data.token);
    } else {
        // अगर पहले से कोई पुराना admin_token पड़ा हो तो उसे साफ़ कर दें
        localStorage.removeItem('admin_token');
    }

    dispatch(loginUser({ token: data.token, user: data.user }));
    setIsOpen(false);
                
                dispatch(loginUser({ token: data.token, user: data.user }));
                setIsOpen(false);
            } else if (authMode === 'register') {
                alert('Account registration initiated successfully! Please check your email for verification.');
                setAuthMode('login');
            } else if (authMode === 'forgot') {
                alert(data.message || 'Password reset link / instructions sent to your email.');
                setAuthMode('login');
            }
        } catch (err) {
            setLocalError(err.message);
        } finally {
            setActionLoading(false);
        }
    };

    return (
        <div className="modal-backdrop-layer" onClick={() => setIsOpen(false)}>
            <div className="modal-viewport-card" onClick={(e) => e.stopPropagation()}>
                <button className="btn-modal-close-x" onClick={() => setIsOpen(false)}>&times;</button>
                
                <header className="modal-header-block">
                    {authMode === 'login' && <h2>Welcome Back</h2>}
                    {authMode === 'register' && <h2>Create Secure Account</h2>}
                    {authMode === 'forgot' && <h2>Account Recovery</h2>}
                    <p>Access high-throughput transactional customer portals instantly</p>
                </header>

                {localError && <div className="modal-alert-error-strip">{localError}</div>}

                <form onSubmit={handleFormSubmit} className="modal-interactive-form">
                    {authMode === 'register' && (
                        <div className="form-input-group">
                            <label>Full Name</label>
                            <input type="text" name="name" required value={formData.name} onChange={handleInputChange} placeholder="John Doe" />
                        </div>
                    )}

                    <div className="form-input-group">
                        <label>Email</label>
                        <input type="email" name="email" required value={formData.email} onChange={handleInputChange} placeholder="name@domain.com" />
                    </div>

                    {/* 🎯 FIX 2: Fixed type to 'tel' for length controls */}
                    {authMode === 'register' && (
                        <div className="form-input-group">
                            <label>Mobile Number (Verification Target)</label>
                            <input type="tel" name="phone" maxLength="10" minLength="10" required value={formData.phone} onChange={handleInputChange} placeholder="987678****" />
                        </div>
                    )}

                    {authMode !== 'forgot' && (
                        <div className="form-input-group">
                            <label>Password</label>
                            <input type="password" name="password" required value={formData.password} onChange={handleInputChange} placeholder="••••••••" />
                        </div>
                    )}

                    {authMode === 'login' && (
                        <span className="lbl-forgot-password-trigger" onClick={() => setAuthMode('forgot')}>Forgot your password?</span>
                    )}

                    {/* 🎯 FIX 3: Dynamic Submit Button Label */}
                    <button type="submit" className="btn-modal-submit-action" disabled={actionLoading}>
                        {actionLoading 
                            ? 'Synchronizing Stream...' 
                            : authMode === 'login' 
                                ? 'Authenticate Session' 
                                : authMode === 'register' 
                                    ? 'Register Core Identity' 
                                    : 'Send Recovery Request'}
                    </button>
                </form>

                <footer className="modal-view-footer-switch-panel">
                    {authMode === 'login' ? (
                        <p>New to platform? <span onClick={() => setAuthMode('register')}>Create an account</span></p>
                    ) : (
                        <p>Already mapped into registry? <span onClick={() => setAuthMode('login')}>Return to Login</span></p>
                    )}
                </footer>
            </div>
        </div>
    );
};

export default LoginRegisterModal;